import React from 'react';
import "./Loader.css";

function Loader () {
    return (
        <div className='loader-container'>
            <div className='loader-inner-container'>
                <div className='loader-gif'>

                </div>
                <div className='loader-animate'>
                    <span className="loader"></span>
                    <span className="loader"></span>
                    <span className="loader"></span>
                    <span className="loader"></span>
                    <span className="loader"></span>
                    <span className="loader"></span>
                    <span className="loader"></span>
                    <span className="loader"></span>
                    <span className="loader"></span>
                    <span className="loader"></span>
                    <span className="loader"></span>
                    <span className="loader"></span>
                    <span className="loader"></span>
                    <span className="loader"></span>
                    <span className="loader"></span>
                </div>
                <div className='loader-content'>
                    <span>"Revolutionizing laundry for a cleaner world"</span>
                    <a href="https://appyard.co.in/"><img src={require("../../images/appyard-logo.png")} height={100} alt="" /></a>
                </div>
            </div>
        </div>
    )
}

export default Loader